"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageQuestionModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class ImageQuestionModule extends base_1.SelectModule {
    constructor(_a) {
        var { showLabels = true } = _a, rest = __rest(_a, ["showLabels"]);
        super(rest);
        this._type = "ImageQuestion";
        this.showLabels = showLabels;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            return {
                actionRequired: this.actionRequired,
                id: this.id,
                options: this.options.map((opt) => {
                    const option = {
                        id: opt.id || (0, util_1.generateUUID)(),
                        src: opt.src,
                    };
                    if (opt.label) {
                        option.label = opt.label;
                    }
                    return option;
                }),
                required: this.required,
                showLabels: this.showLabels,
                label: this.label,
                type: this.type,
                noBorder: this.noBorder,
            };
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        const _b = this.toBuilderConfig(), { required, label } = _b, base = __rest(_b, ["required", "label"]);
        const surveyConfigModule = Object.assign(Object.assign({}, base), { options: this.options.map((opt) => {
                var _a, _b;
                return ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    src: (_b = opt.src) === null || _b === void 0 ? void 0 : _b[this.languageCode],
                });
            }), header: { children: (_a = label === null || label === void 0 ? void 0 : label[this.languageCode]) !== null && _a !== void 0 ? _a : "" } });
        if (required) {
            surveyConfigModule.validation = (0, util_1.addRequiredValidation)();
        }
        return surveyConfigModule;
    }
    editProps() {
        var _a;
        if (this.validate())
            return {
                id: this.id,
                options: this.options.map((opt) => {
                    var _a, _b;
                    return ({
                        id: opt.id || (0, util_1.generateUUID)(),
                        label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                        src: (_b = opt.src) === null || _b === void 0 ? void 0 : _b[this.languageCode],
                    });
                }),
                type: this.type,
                question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
                actionRequired: this.actionRequired,
            };
    }
}
exports.ImageQuestionModule = ImageQuestionModule;
//# sourceMappingURL=ImageQuestion.js.map